/// <reference path="ProductClassificationCell.ts" />

// The classifications a product is marked with (material, service, ...): a table of titles
// managed like the document categorization.

class ProductClassificationViewController extends MUIViewController
{
    static newInstance() : ProductClassificationViewController
    {
        let vc = new ProductClassificationViewController("product-classification-view");
        vc.initWithResource("layout/setup/ProductClassificationView.html");
        return vc;
    }

    private saveButton:MUIButton = null;
    private addButton:MUIButton = null;
    private tableView:UITableView = null;

    get title(){
        return MIOLocalizeString("PRODUCT_CLASSIFICATION", "PRODUCT CLASSIFICATION");
    }

    viewDidLoad(){
        super.viewDidLoad();

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.managedObjectContext.save();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addButtonDidPress);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.tableView.reloadData();
    }

    numberOfSections(tableview){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview, section){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("ProductClassificationCell") as ProductClassificationCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ProductClassification;
        cell.item = item;
        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) : any {
        return MUITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath);
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.managedObjectContext.deleteObject(item);
            ad.managedObjectContext.save();
        }
    }

    private addButtonDidPress(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_PRODUCT_CLASSIFICATION", "NEW PRODUCT CLASSIFICATION"), MIOLocalizeString("CHOOSE_A_TITLE", "CHOOSE A TITLE"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
           textField.setPlaceholderText(MIOLocalizeString("TITLE", "TITLE"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text;
            if (name == null || name.trim().length == 0) return;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let c = MIOEntityDescription.insertNewObjectForEntityForName("ProductClassification", ad.managedObjectContext) as ProductClassification;
            c.title = name.trim();

            ad.managedObjectContext.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    // MARK: - Fetched results controller

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (this._fetchedResultsController != null) {
            this._fetchedResultsController.delegate = null;
        }
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("title", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("ProductClassification", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller){
        this.tableView.reloadData();
    }
}
